module.exports = __webpack_public_path__ + "static/media/honda-off-app-provider-icon.31827c75.svg";